<template>
<v-card class="pa-2">
    <div class="detail font-weight-bold pa-0 ma-0">Email &amp; Password</div>
    <v-row no-gutters align="center" class="pt-2 im-search">
        <v-col cols="12" md="6" class="px-2">
            <v-text-field v-model="item.email" class="ma-0 pa-0" :rules="rules.email" label="Email" />
        </v-col>
        <v-col cols="12" md="6" class="px-2">
            <v-text-field class="ma-0 pa-0" v-model="item.password" :rules="rules.min" :type="show_pass ? 'text' : 'password'" :append-icon="show_pass ? 'mdi-eye' : 'mdi-eye-off'" label="Password" counter required @click:append="show_pass = !show_pass"></v-text-field>
        </v-col>
        <v-col cols="12" md="6" offset-md="6" class="px-2">
            <v-text-field class="ma-0" v-model="item.password_confirmation" :rules="rules.match" label="Password Confirmation" :type="show_conf ? 'text' : 'password'" :append-icon="show_conf ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show_conf = !show_conf"
                counter></v-text-field>
        </v-col>
    </v-row>
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";

export default {
    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },
    components: {},
    data() {
        return {
            //props
            pass: false,
            password: '',
            passconfirm: false,
            password_confirmation: '',
            show_pass: false,
            show_conf: false,

            user: this.$clone(defaults.user_item),

            rules: {
                email: [
                    v => !!v || "E-mail is required",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
                ],
                min: [v => /(?=.{8,})/.test(v) || 'Min 8 characters'],
                match: [v => this.item.password === this.item.password_confirmation || "Password must match"]
            },

        };
    },

    computed: {},

    watch: {},

    methods: {

        ...mapActions('alert', ['success', 'error']),

    }
};
</script>
